import { useCallback as v, useEffect as c } from "react";
import { useQuill as x } from "../../../../adapters/quill/useQuill/index.js";
import { createUrlKeyboardHandler as y } from "../../../../adapters/quill/helpers/handlers/index.js";
import { modules as L, formats as w } from "../../settings.js";
import { QuillDeltaToHtmlConverter as D } from "quill-delta-to-html";
import { replaceEmptyParagraphsToBr as H } from "../../../../services/html/index.js";
import { URL_REGEX as R } from "../../../../services/regex/index.js";
import { mergeDeep as O } from "../../../../services/utils/index.js";
function _({
  modules: p,
  formats: u = w,
  theme: d,
  defaultValue: g,
  replaceBeforeSend: s,
  extensions: k,
  onChange: e,
  ...E
}) {
  const { quill: t, ...h } = x({
    modules: O(L, p || {}),
    theme: d || "snow",
    formats: u,
    extensions: k,
    defaultValue: g,
    ...E
  }), i = v(() => {
    setTimeout(() => {
      const n = t == null ? void 0 : t.getContents();
      if (!n)
        return;
      const o = t == null ? void 0 : t.getText(), T = /https?:\/\/[^\s]+/g, f = o == null ? void 0 : o.match(T);
      f && f.forEach((r) => {
        const m = (o == null ? void 0 : o.indexOf(r)) || 0;
        m !== -1 && (t == null || t.formatText(m, r.length, { link: r }));
      });
      const a = new D(n.ops, {
        multiLineParagraph: !1,
        customTagAttributes: (r) => {
          if (r.attributes.link)
            return { "data-ignorepreview": "true" };
        }
      });
      s == null || s.forEach((r) => {
        a.renderCustomWith(r);
      });
      const b = H(a.convert() || "");
      e == null || e(`<p>${b}</p>`);
    }, 0);
  }, [t, e, s]);
  return c(() => (t == null || t.on("text-change", i), () => {
    t == null || t.off("text-change", i);
  }), [t]), c(() => {
    if (!t)
      return;
    const n = y(R, t);
    t == null || t.keyboard.addBinding({ key: " " }, n);
  }, [t]), { quill: t, ...h };
}
export {
  _ as useDefaultEditorOptions
};
